export interface GetNameOptions {
  context: string;
  feature: string;
  section: string;
}

export function getName({
  context,
  feature,
  section,
}: Partial<GetNameOptions>): string {
  const unique = new Set<string>();
  const aux: string[] = [];
  if (context) {
    unique.add(`${context.trim()}`);
  }

  if (feature) {
    unique.add(`${feature.trim()}`);
  }

  if (section) {
    unique.add(`${section.trim()}`);
  }

  unique.forEach((x) => {
    aux.push(x);
  });

  const rv = aux.join('_');
  return rv;
}
